import LearningPotential from  './routes/LearningPotential' //学习潜力
import LearningMotivation from  './routes/LearningMotivation' //学习动力
import LearningEffectiveness from  './routes/LearningEffectiveness' //学习效力
import mentalHealth from  './routes/mentalHealth' //心里健康
// 导航页
const Navgation1 = () => import('@/views/ceping/LearningAbility/Navigations/part1.vue');
const Navgation2 = () => import('@/views/ceping/LearningAbility/Navigations/part2.vue');
const Navgation3 = () => import('@/views/ceping/LearningAbility/Navigations/part3.vue');
const Navgation4 = () => import('@/views/ceping/LearningAbility/Navigations/part4.vue');
export default  {
    learningAbility:[
        {
            path: '/',
            name: '学习潜力导航',
            component: Navgation1,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/learningAbility/Navgation2',
            name: '学习动力导航',
            component: Navgation2,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/learningAbility/Navgation3',
            name: '学习效力导航',
            component: Navgation3,
            meta:{requireAuth:true,roles:['student']},
        },
        {
            path: '/learningAbility/Navgation4',
            name: '心理健康导航',
            component: Navgation4,
            meta:{requireAuth:true,roles:['student']},
        },
        ...LearningPotential,
        ...LearningMotivation,
        ...LearningEffectiveness,
        ...mentalHealth
    ]
}
